import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { ProductCard } from "./ProductCard";

export function ProductRow({ title, products, link, accent }) {
  if (!products || products.length === 0) return null;
  return (
    <section className="bg-white rounded-md border border-zinc-200 overflow-hidden">
      <div className="flex items-center justify-between px-4 py-3 border-b border-zinc-100">
        <h2 className={`font-display text-lg font-bold ${accent ? "text-[#E23744]" : "text-zinc-900"}`}>{title}</h2>
        {link && <Link to={link} className="text-xs text-[#FF6A1A] font-semibold flex items-center gap-0.5">See all <ChevronRight size={13} /></Link>}
      </div>
      <div className="flex gap-3 overflow-x-auto scrollbar-hide p-3">
        {products.map((p) => (
          <div key={p.id} className="w-[160px] sm:w-[185px] shrink-0"><ProductCard product={p} /></div>
        ))}
      </div>
    </section>
  );
}

export function ProductGrid({ products }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-3" data-testid="product-grid">
      {products.map((p) => <ProductCard key={p.id} product={p} />)}
    </div>
  );
}
